import {
  Graph,
  BasicInfo,
  Historicity,
  Documents
  } from './components';

export const stepsBeneficiary = [
  {
    name: 'GRAPH',
    label: 'Συνοπτική Παρουσίαση Κατάστασης Αίτησης',
    Component: Graph,
    id: 0,
  },
  {
    name: 'INFO',
    label: 'Στοιχεία Αίτησης',
    Component: BasicInfo,
    id: 1,
  },
  {
    name: 'DOCUMENTS',
    label: 'Έγγραφα',
    Component: Documents,
    id: 2,
  },
  {
    name: 'HISTORICITY',
    label: 'Ιστορικότητα',
    Component: Historicity,
    id: 3,
  },
  ];